import { useState } from "react"
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

const EasyAccordian = ({header, children, startOpen = false, disabled = false}) =>{

    const [open, setOpen] = useState(startOpen);

    return(
        <div>
            <div onClick={()=>{if(!disabled) setOpen(!open)}}>
                {open?
                <div className="subHeading m-0">
                    <ArrowDropDownIcon style={{fontSize: '2.5rem'}}/><span>{header}</span>
                </div>
                :
                <div className="subHeading m-0" style={{cursor: disabled ? "default" : "pointer"}}>
                    <ArrowRightIcon style={{color: disabled ? "var(--appTextColor)" : "inherit", opacity: disabled ? 0.45 : 1, fontSize: '2.5rem'}}/><span style={{color: disabled ? "var(--appTextColor)" : "inherit", opacity: disabled ? 0.45 : 1}}>{header}</span>
                </div>
                }
            </div>
            
                <div
                    style={{
                        maxHeight: open ? '1000px' : '0px',
                        overflow: 'hidden',
                        transition: 'max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                    }}
                >
                    {children}
                </div>
        </div>
    )

}
export default EasyAccordian